import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Link from '@mui/material/Link'
import { LoginForm, useAuth, type SignedIn } from '@jupi/ui'

// The sign-in card itself is shared with the huolto app (packages/ui); this
// is the member app's part: where to go afterwards, and its reset-password page.
export default function LoginPage() {
  const { t } = useTranslation()
  const { acceptSession } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  const signedIn: SignedIn = (user) => {
    acceptSession(user)
    const from = (location.state as { from?: string } | null)?.from
    navigate(from && from !== '/login' ? from : '/', { replace: true })
  }

  return (
    <LoginForm
      onSignedIn={signedIn}
      forgotPassword={
        <Link component={RouterLink} to="/forgot-password" variant="body2" sx={{ alignSelf: 'center' }}>
          {t('auth.forgotPassword')}
        </Link>
      }
    />
  )
}
